
  
class ecomCheckout {
    #token
    #randomVal
    #date
    #checkoutBtn = document.querySelector(`.tem-checkout_btn`);
    #checkoutCartImage = document.querySelector(`.tem-checkout_btn span`);
    #checkoutLoadingImg = document.querySelector(`.tem-checkout_btn img`);
    #cartItems =[]
    #mobileNumber = ""
    #mobileError = document.querySelector(`.phon_alert2`);
    #mobileInput = document.querySelector(`[name="attributes[Phone Number]"]`);
    #countryError = document.querySelector(`.phon_alert`);
    promisePhoneValidate
    optInterval
    default_otp_time= 120
    otpCountDown = this.default_otp_time
    otpContainer = document.querySelector(`#OTP_pop_BOX`)
    otpForm = document.querySelector(`.otp_form`);
    otpResend = this.otpContainer.querySelector(`.otp-resetbtn`);
    otpTimeCount =  this.otpContainer.querySelector("#time_count")
    otpResendBtn = this.otpContainer.querySelector(`.otp-resetbtn`);
    otpValidateBtn = this.otpContainer.querySelector(`button.validatedBtn2`);
    otpBoxCloseBtn = this.otpContainer.querySelector(`.close-otp`);
    otpServerID ;
    otpNumberInput = this.otpContainer.querySelector(`#otp_txt`);
    otpIncorrectElem = this.otpContainer.querySelector(`.otp_incorrect_alert`);
    districtPopup =  document.querySelector(`.districtPopup`);
    districtConfirmElem = document.querySelector("#district_confirm");
    checkoutLoadingElem = document.querySelector(`.tem-checkout_btn img`);
    checkoutBtnCart = document.querySelector(`.tem-checkout_btn span`);
    districtCloseBtn = document.querySelector(`.close-district`);
    customerTpElem = document.querySelector(`#meta-customerTp`).getAttribute("value");
    smsSendUrl = "https://udev.secureapps.center/api/get-phone-number";
    smsCheckUrl = "https://udev.secureapps.center/api/get-phone-number-otp";
    cryptSmsSendUrl = "https://udev.secureapps.center/api/generate-otp";
    cryptSmsCheckUrl = "https://udev.secureapps.center/api/check-otp";
    usdPurchaseUrl = "https://udev.secureapps.center/api/send-new-international-order "
    #usdRateApi = "https://udev.secureapps.center/api/get-usd-rate";
    #discountCodeValidate = "https://udev.secureapps.center/api/check-discount-eligible";
    #usdRate = ecomReqCurrencies.currencyList.LKR;
    #customer_id = document.querySelector(`#meta-customerId`).getAttribute("value");
    #foreignDiscountElem = document.querySelector("#foreignDiscount");
    #buyUSDElem = document.querySelector("#byUSD");
    #debounceForeignDiscount = "";
    #errorDiscountCodeElem = document.querySelector(".ecomErrorDiscount");
    #successDiscountCodeElem = document.querySelector(".ecomSuccessDiscount");
    imIn = document.getElementById("im-in").dataset.template;
    imFrom = "";
    #whm_cart_token;
    
    constructor() {
      this.asyncConstructor();
      this.getAndUpdateUsdRate();
      
      if(this.getCookie("Cus_mobile") == "") {
        this.setCookie("Cus_mobile",this.customerTpElem, 7)
      }
      
      this.#mobileNumber = this.getCookie("Cus_mobile").replace("+","");
    }

    mobileSetter(phone) {
      this.#mobileNumber = phone
    }

     getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return "";
    }

    setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
  
    async  asyncConstructor() {
        this.createListeners()
        
        // await this.getCartData();
        // await this.phoneValidate()
        // this.districtConfirm()
        //first check phone number set and valid
        //after validation then check  exeding promo
        //if not exceeding show district picker
        //then call to get Cart data
        //then check invenotiry available
        //
    }

    createListeners() {
        this.otpResendBtn?.addEventListener("click", this.otpTimeoutResend.bind(this), false);
        if(this.imIn == "cart") {
          this.otpValidateBtn?.addEventListener("click", this.otpCodeValidate.bind(this), false);
        }
        this.districtConfirmElem?.addEventListener("click", this.districtConfirm.bind(this),false);
        this.#checkoutBtn?.addEventListener("click", this.checkout.bind(this),false);
        this.otpBoxCloseBtn?.addEventListener("click", this.otpClose.bind(this), false);
        this.districtCloseBtn?.addEventListener("click", this.districtClose.bind(this), false);
        this.#buyUSDElem?.addEventListener("change", this.showHideDiscountElem.bind(this), false);
        this.#foreignDiscountElem?.addEventListener("input", this.debounceInputForeignDiscount.bind(this), false);
        
    }

    inCartChangeCurrencyRedirect() {
      
    }
    
    debounceInputForeignDiscount (e) {
      this.resetForeignDiscountElem()
      clearTimeout(this.#debounceForeignDiscount);
        this.#debounceForeignDiscount = setTimeout( function(){
          this.validateDiscountUSD();
        }.bind(this), 400);
      return;
    }

    resetForeignDiscountElem () {
      this.#successDiscountCodeElem.classList.add("ecom_hide");
      this.#errorDiscountCodeElem.classList.add("ecom_hide");
    }
    
    async validateDiscountUSD() {
      const discountCode = this.#foreignDiscountElem.value.trim();
      if(discountCode == "") {
        this.resetForeignDiscountElem()
        return;
      }
 
      const _fetch = await fetch(this.#discountCodeValidate, {
        method: "POST",
        headers: {
          "Content-Type":"application/json"
        },
        body: JSON.stringify( { "discount_code": discountCode, "apiRandKey": apiRandKey  } )
      });
      
      const response = await _fetch.text();
      
      if(response.trim() != "eligible") {
        this.#errorDiscountCodeElem.classList.remove("ecom_hide");
        return;
      }
      if(response.trim() == "eligible") {
        this.#successDiscountCodeElem.classList.remove("ecom_hide");
      }
    }
    
    showHideDiscountElem (e) {
      const checked = this.#buyUSDElem.checked;
      const csDiscountSet = window.csapps?.discounts?.cart_level_discount_applications > 0;

      if(checked && !csDiscountSet) {
        const fromDiscountCookie = getCookie("discount_code");
        this.#foreignDiscountElem.value = fromDiscountCookie;
        this.#foreignDiscountElem.classList.remove("ecom_hide");
      } else {
        this.#foreignDiscountElem.classList.add("ecom_hide")
      }
    }
    
    async getAndUpdateUsdRate() {
      const _fetch = await fetch(this.#usdRateApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify( { "apiRandKey": apiRandKey } )
      });
      const result = await _fetch.json();

      this.#usdRate = result.rate;
      this.updateTotalPrice();
      return
    }

    updateTotalPrice () {
      const labelElem = document.querySelector(`#ecom-label-usd`);
      if(!labelElem) {
        return 
      }
      const totalPrice = ( parseFloat(labelElem.getAttribute("data-ecom-total-price")) * this.#usdRate).toFixed(2);
      labelElem.innerText = `Buy USD ( $${totalPrice} USD )`;
    }
    
    async checkout(e) {
        e.preventDefault();

        const choosenCurrency = window.localStorage.getItem("choosenCurrency");
        
        this.resetElements();
        this.checkoutLoadingElem.style.display = "block";
        this.checkoutBtnCart.style.display = "none";
        this.#checkoutBtn.disabled = true;
        const tosAccept = document.querySelector(`[name="attributes[marketing]"]`).checked;
        
        if(!tosAccept) {
          document.querySelector("#marketing_text").style.color = "red";
          this.enableCheckout();
          return
        }
        document.querySelector("#marketing_text").style.color = "";
      
        const getCartData = await this.getCartData();
        if (!getCartData) {
            window.location.reload;
        }
        const phoneValidate = await this.phoneValidate();
    }

    async phoneValidate(imFrom = "") {
        console.log("phone validating")
        this.imFrom = imFrom;

        //removed mobile number cookie check @ 2023-05-29
        let  cookieMobile = ""; //getCookie("Cus_mobile").replace("+","");

        if(this.imFrom == "card-offer") {
          cookieMobile = getCookie("Cus_mobile").replace("+","");
        }
      
        //check mobile have country
        const hasCountry = document.querySelector(`.iti__selected-flag[title]`);
        if(!hasCountry) {
            this.#countryError.style.display = "block";
            console.log("contry error")
            this.enableCheckout();
            return false;
        }
       
        const countryCode = phoneInput.getSelectedCountryData().iso2;
        let enteredNumber = phoneInput.getNumber();
        let validNumber =  phoneInput.isValidNumber();
        enteredNumber = enteredNumber.replaceAll("+","");
        
        //if number contains 074 then return true, because dialog have 074 
        console.log(enteredNumber.length);
        console.log(enteredNumber);
        console.log(enteredNumber.startsWith("+9474"));
        if(enteredNumber.length == 11 && enteredNumber.startsWith("9474")) {
          console.log("Set valid number ");
          validNumber = true
        }
          
        this.#mobileNumber =  phoneInput.getNumber();
        this.#mobileNumber = this.#mobileNumber.replace("+","")
        if(this.#mobileNumber == "") {
            this.#mobileError.style.display = "block";
            this.#mobileInput.classList.add("border-error");
            console.log("mobile number")
            this.enableCheckout()
            return false;
        }

        console.log({validNumber, countryCode});
        if( !validNumber && countryCode == "lk") {
          this.#mobileError.style.display = "block";
          this.#mobileInput.classList.add("border-error");
          console.log("mobile number length error");
          this.enableCheckout()
          return false;
        }

        //removed mobile number cookie check @ 2023-05-29
        if(this.#mobileNumber == cookieMobile && false) {
            console.log("same cookie")

            //check is user not sri lanka number if yes then call to USD remittance if customer sets ecomGeoRedirectToRemittance cookie available
            const ecomGeoRedirectToRemittance = this.getCookie("ecomGeoRedirectToRemittance");
            if( this.#mobileNumber.includes("94",0) == false) {
              console.log("same cookie , not in sri lanka, mobile number is starting not 94 and customer is not inside sri lanka then USD call")
              bringToCartByCurrencyObj.checkAndRedirect()
              return;
            }

            if(imFrom == "card-offer") {
              return "mobile-verified";
            }
          
            this.showDistrictDropdown();
            return true;
        }

        console.log("below card offer check when otp update")
        if(imFrom == "card-offer" && this.#mobileNumber == cookieMobile ) {
            console.log("from card - offer")
            this.otpClose();
            return "mobile-verified";
        }

        //when cookie value and phone value is different call to verify
        console.log(this.#mobileNumber);

        //check backend set to dont ask otp 
        const stopSendOtp = document.querySelector("#otp_sent_on_off")?.value || "false";
        if(stopSendOtp == "true") { //skip otp verification
          setCookie("Cus_mobile", this.#mobileNumber, 7);
          this.showDistrictDropdown();
          return true;
        }

        this.is_otp_req_faild = false;
        try {
          const _fetch = await ecomSendOtp(this.#mobileNumber);
        } catch(e) {
          this.is_otp_req_faild = true;
          console.log("Fetch error ecom send OTP");
        }

        //get skip_otp_verify_after_time value and wait til time reach or process rest
        const skip_otp_verify_after_time = +document.querySelector("#skip_otp_verify_after_time").value;
      
        //show phone validate
        this.otpContainer.style.display = "block";
        this.optInterval = setInterval(function() {
            if(this.otpCountDown > 0) {
                this.otpCountDown -= 1;
              console.log(this.otpCountDown)
               this.otpTimeCount.innerHTML = `<span>${this.otpCountDown}</span>s`;
            }
            
            if(skip_otp_verify_after_time != 0 && (this.default_otp_time - this.otpCountDown) == skip_otp_verify_after_time && this.is_otp_req_faild ) {
              this.otpClose();
              clearInterval(this.optInterval);
              if(this.imFrom == "card-offer") {
                setCookie("Cus_mobile", this.#mobileNumber, 7);
                window.dispatchEvent(new CustomEvent("mobile-verified"));
                return "mobile-verified";
              }
              this.showDistrictDropdown();
              return true;
            }
            if(this.otpCountDown <=0) {
                this.otpTimeCount.style.display = "none";
                this.otpResend.style.display = "block";
                this.otpForm.style.display = "none";
                this.otpValidateBtn.disabled = false;
                clearInterval(this.optInterval);
            }
        }.bind(this), 1000);
      
        return true;
    }

    otpClose (e) {
      clearInterval(this.optInterval);
      this.otpTimeCount.style.display = "Block";
      this.otpResend.style.display = "none";
      this.otpForm.style.display = "block";
      this.otpCountDown = this.default_otp_time
      this.otpValidateBtn.disabled = false;
      this.otpIncorrectElem.style.display ="none";
      this.otpContainer.style.display = "none"
      this.enableCheckout();
      console.log("otpClose clicked")
    }

    districtClose () {
      this.districtPopup.style.display = "none";
      this.enableCheckout();
    }
    
    async otpCodeValidate() {
        const otpServerId = this.otpServerID;
        const phoneNumber = this.#mobileNumber;
        const otpCode = this.otpNumberInput.value;

        console.log(otpServerId, otpCode)
        //disable validate button
        this.otpValidateBtn.disabled = true;
      
        console.log("waiting for verify OTP");
        console.log("im from", this.imFrom);
        const _response = await ecomVerifyOtp(otpCode);
        console.log(_response);
        if(_response.otp == "error") {
            this.otpIncorrectElem.style.display ="block";
            this.otpValidateBtn.disabled = false;
            return;
        }


        this.otpClose();
      
        //when true then show district dropdown
        this.otpContainer.style.display = "none";
        setCookie("Cus_mobile", this.#mobileNumber, 7);

        //check is user not sri lanka number if yes then call to USD remittance if customer sets ecomGeoRedirectToRemittance cookie available
        const ecomGeoRedirectToRemittance = this.getCookie("ecomGeoRedirectToRemittance");
        if(this.#mobileNumber.includes("94",0) == false) {
          console.log("not in sri lanka, mobile number is starting not 94 and customer is not inside sri lanka then USD call")
          bringToCartByCurrencyObj.checkAndRedirect()
          return;
        }

        if(this.imFrom == "card-offer") {
          window.dispatchEvent(new CustomEvent("mobile-verified"));
          return "mobile-verified";
        }
        
        this.showDistrictDropdown(); 
    }

    showDistrictDropdown () {
        this.districtPopup.style.display = "block";
        document.querySelector('.districtPopup .close-district').scrollIntoViewIfNeeded({block: "start"})
    }

    distrctPopupReset () {
      document.querySelector(`#district-divisionPopup`).style.border = "";
      this.districtConfirmElem.querySelector(`img.confirmDistrict`).style.display = "none";
      this.districtConfirmElem.querySelector(`span`).style.display = "block";
      this.districtConfirmElem.disabled = false
      
    }

    async whmCartTokenGenerate() {
      const cartData = {};
      cartData.cartItems = [];
      cartData.phoneNumber = "1231312";
      cartData.otp = "31231";
      
      for(let i =0; i < cartItems.length; i++) {
          const temp = {};
          temp.product_id = cartItems[i].product_id;
          temp.variant_id = cartItems[i].variant_id;
          temp.itemCount = cartItems[i].qty;
  
          cartData.cartItems.push(temp);
      }
  
      const encryptedData = encriptGivenData(JSON.stringify(cartData));
  
      //here needs to implement API call part and token assign to global variable
    }

    isValidDate(dateString) {
        // Regular expression to match the format dd-MM-yyyy
        const regex = /^(\d{2})-(\d{2})-(\d{4})$/;
        const match = dateString.match(regex);
        
        if (!match) {
            return false; // Not in the format dd-MM-yyyy
        }
    
        // Extract day, month, and year from the regex match
        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10);
        const year = parseInt(match[3], 10);
    
        // Validate month range (1-12)
        if (month < 1 || month > 12) {
            return false;
        }
    
        // Validate day range based on the month and year
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) {
            return false;
        }
    
        // Check if the date is in the future
        const inputDate = new Date(year, month - 1, day);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set time to midnight for an accurate comparison
    
        if (inputDate <= currentDate) {
            return false; // The date is not in the future
        }
    
        return true;
    }

    getFormattedDate(date = new Date()) {
      const now = new Date(date);
      
      // Get the individual components
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours() % 12 || 12).padStart(2, '0'); // 12-hour format
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const ampm = now.getHours() >= 12 ? 'PM' : 'AM';
  
      // Format the string
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}${ampm}`;
    }
    
    async districtConfirm() {
        this.distrctPopupReset();
        const key = token;
        const mstring = string;
        this.districtConfirmElem.disabled = true;
        const note = document.getElementById("cart-note").value;
        this.districtConfirmElem.querySelector(`span`).style.display = "none";
        this.districtConfirmElem.querySelector(`img.confirmDistrict`).style.display = "block";
        
        let giftWrapping = document.querySelector(`[name="attributes[Purchase Options]"]:checked`).value;
        const district = document.querySelector(`#district-divisionPopup`).value;
        const marketting = document.querySelector(`[name="attributes[marketing]"]`).checked;
        const acceptMarketting = document.querySelector(`[name="attributes[accepts_marketing]"]`).checked;

        const geoData = JSON.parse(window.localStorage.getItem("ecomGeoData"));
      
        //validate district is set
        if(district == "") {
            document.querySelector(`#district-divisionPopup`).style.border = "1px solid red";
            this.districtConfirmElem.querySelector(`img.confirmDistrict`).style.display = "none";
            this.districtConfirmElem.querySelector(`span`).style.display = "block";
            this.districtConfirmElem.disabled = false
            return;
        }
        
        if(giftWrapping == "myself"){
            giftWrapping = "no";
        } else {
            giftWrapping = "yes";
        }
            
        const noteAttributes = [
            { name:"phone", value: this.#mobileNumber  },
            { name:"gift", value: giftWrapping}
        ];

        const items  =[];
        for(let item of this.#cartItems) {
            const tempObj = {
                "price": item.defaultPrice,
                "quantity": item.qty,
                "variant_id":item.variant_id
            }
            items.push(tempObj);
        }

        const payload = {
            key,
            mstring,
            note,
            note_attributes: noteAttributes,
            items,
            "apiRandKey": apiRandKey
        }


        // const _fetch = await fetch(check_url, {
        //     method: "POST",
        //     headers: {
        //         "Content-Type":"application/json"
        //     },
        //     body: JSON.stringify(payload)
        // });

        // const _reply = await _fetch.json();
        // console.log(_reply);
        console.log("is otp req failed", this.is_otp_req_faild);
        const isNotExceeding = validateExceedingPromo(this.is_otp_req_faild);

        if(!isNotExceeding) {
            this.districtClose();
            return;
        }

        //await updatePromoCapFromCart();

        const cartDataForm = new FormData();
        
        const customerId = document.querySelector('m_customer_id');
        if(customerId) {
          cartDataForm.append("attributes[customerId]", customerId.value)
        }
        if(giftWrapping == "no") {
            cartDataForm.append("attributes[Purchase Options]", "Buy for Myself");
        }
        if(giftWrapping == "yes") {
            cartDataForm.append("attributes[Purchase Options]", "Gift Wrapping");
        }
        if(marketting ) {
          cartDataForm.append("attributes[marketing]", "Yes");
        } else {
          cartDataForm.append("attributes[marketing]", "Yes");
        }
        if(acceptMarketting) {
          cartDataForm.append("attributes[accepts_marketing]", "Yes");
        } else {
          cartDataForm.append("attributes[accepts_marketing]", "No");
        }
        cartDataForm.append("note", note);
        cartDataForm.append("attributes[Delivery Date]", document.querySelector(`[name="attributes[Delivery Date]"]`).value);
        cartDataForm.append("attributes[District Division]", document.querySelector(`#district-divisionPopup`).value );
        cartDataForm.append("attributes[Phone Number]", this.#mobileNumber);
        cartDataForm.append("attributes[country]", geoData.country);
        cartDataForm.append("attributes[country_code]", geoData.country_code);
        cartDataForm.append("country", geoData.country);
        cartDataForm.append("country_code", geoData.country_code);

        const deliveryDate =  $("#delivery-date").datepicker({ dateFormat: 'dd-MM-yyyy' }).val();
        
        if(this.isValidDate(deliveryDate)) {
          console.log("valid delivery date");
          const dateTimePicked = $("#delivery-date").attr("data-selected-datetime");
          cartDataForm.append("attributes[Delivery Date]",  deliveryDate);
          cartDataForm.append("attributes[Cart created at]",  this.getFormattedDate(dateTimePicked));
        }else {
          cartDataForm.append("attributes[Cart created at]", "");
        }
      
        const formFetch = await fetch("/cart", {
            method: "POST",
            body: cartDataForm
        });
        
        const result =  await formFetch.text();
        console.log(result);

        //try to fetch discount and send to checkout
        try {
          await loyalty_points.redeem_points();
        }catch(e) {
          console.log("ERR loyalty discount genereate issue " + e);
        }

        //check payingcurrencty check
        const payingCurrency = document.querySelector(`[name="payingcurrency"]`).checked ;
        if(payingCurrency == false) {
            csappsCheckout();
           return 
        }

        this.callToUSD();
        //when USD call to USD setup and redirect user
    }

    async callToUSD () {
        //cart promo margin fix
        await this.promoMarginCartFix();
        await this.getCartData()

        let giftWrapping = document.querySelector(`[name="attributes[Purchase Options]"]:checked`).value;
        const district = document.querySelector(`#district-divisionPopup`).value;
        const orderNote = document.getElementById("cart-note").value;
        let marketting = document.querySelector(`[name="attributes[marketing]"]`).checked;
        let acceptMarketting = document.querySelector(`[name="attributes[accepts_marketing]"]`).checked;
      
        if(marketting ) {
          marketting = "Yes"
        } else {
          marketting = "No"
        }

      if(acceptMarketting) {
        acceptMarketting = "Yes"
      } else {
        acceptMarketting = "No"
      }
      
        const note = [
          { "name": "District Division", "value" : district },
          { "name": "marketing", "value": marketting },
          { "name": "accepts_marketing", "value": acceptMarketting },
          { "name": "currency", "value": "USD"},
          { "name": "phone", "value":  this.#mobileNumber }, 
          { "name": "note" , "value" : orderNote }, 
        ];
      
        const usdObj = {};
        const usdItems = [];
        console.log(this.#cartItems);
      
        for(let item of this.#cartItems) {
            const obj = {}
            obj.price = parseFloat(item.defaultPrice) * this.#usdRate
            obj.variant_id = item.variant_id
            obj.itemCount = item.qty
            obj.defaultPrice = item.defaultPrice
            usdItems.push(obj)
        }

        if(csapps?.discounts?.cart_level_discount_applications?.length >0 ) {
          usdObj.ad = this.#encryptAES( csapps.discounts);
        } else {
          usdObj.ad = "";
        }
        usdObj.rate = this.#usdRate;
        usdObj.date = this.#date
        usdObj.randomVal = this.#randomVal
        usdObj.token = this.#token
        usdObj.items = usdItems
        usdObj.note = note
        usdObj.customer_id = this.#customer_id
        usdObj.discount_code = this.#foreignDiscountElem?.value || "";
        console.log("usdObj",usdObj)
      
        const _fetch = await fetch(this.usdPurchaseUrl, {
          method: "POST",
          headers: {
            "Content-Type":"application/json"
          },
          body: JSON.stringify(usdObj)
        })
        const result = await _fetch.text();
        if(_fetch.status ==200) {
          const randId = result.split("rand=")[1];
          window.location.href = "https://ustore-usdtest.myshopify.com/?id="+randId;
          return;
        }
      console.log(result)
    }

    async redirectToRemittanceSite () {
        //cart promo margin fix
        await this.promoMarginCartFix();
        await this.getCartData()
        const geoData = JSON.parse(window.localStorage.getItem("ecomGeoData"));
      
        const note = [
          { "name": "District Division", "value" : "" },
          { "name": "marketing", "value": "" },
          { "name": "accepts_marketing", "value": "" },
          { "name": "currency", "value": "USD"},
          { "name": "phone", "value":  this.#mobileNumber  }, 
          { "name": "note" , "value" : "" }, 
          { "name": "country" , "value" : geoData.country }, 
          { "name": "country_code" , "value" : geoData.country_code }, 
          { "name": "apiRandKey", "value": apiRandKey }
        ];
      
        const usdObj = {};
        const usdItems = [];
        console.log(this.#cartItems);
      
        for(let item of this.#cartItems) {
            const obj = {}
            obj.price = ecomReqCurrencies.convertCurrency(parseFloat(item.defaultPrice), "LKR", "USD") //parseFloat(item.defaultPrice) * this.#usdRate
            obj.variant_id = item.variant_id
            obj.itemCount = item.qty
            obj.defaultPrice = item.defaultPrice
            usdItems.push(obj)
        }

        if(csapps.discounts?.cart_level_discount_applications?.length >0 ) {
          usdObj.ad = this.#encryptAES( csapps.discounts);
        } else {
          usdObj.ad = "";
        }
        usdObj.rate = ecomReqCurrencies.currencyList.LKR.rate;
        usdObj.date = this.#date
        usdObj.randomVal = this.#randomVal
        usdObj.token = this.#token
        usdObj.items = usdItems
        usdObj.note = note
        usdObj.customer_id = this.#customer_id
        usdObj.discount_code = "";
        usdObj.cus_mobile = this.getCookie("Cus_mobile").replace("+","");
        usdObj.apiRandKey = apiRandKey;
        console.log("usdObj",usdObj)
      
        const _fetch = await fetch(this.usdPurchaseUrl, {
          method: "POST",
          headers: {
            "Content-Type":"application/json"
          },
          body: JSON.stringify(usdObj)
        })
        const result = await _fetch.text();
        if(_fetch.status ==200) {
          const randId = result.split("rand=")[1];
          //window.location.href = 
          //return "https://ustore-usdtest.myshopify.com/?id="+randId;
          return result;
        }
      console.log(result)
    }


   #encryptAES (data) {
      let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
      key = CryptoJS.enc.Utf8.parse(key);
      let iv = "O_1ltX'0Po>/hA*v";
      iv = CryptoJS.enc.Utf8.parse(iv);

      let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, { iv: iv }).toString();
      console.log(encrypted);
      return encrypted;
    }
    
    otpTimeoutResend() {
        //reset elements
        this.otpTimeCount.style.display = "Block";
        this.otpResend.style.display = "none";
        this.otpForm.style.display = "block";
        this.otpCountDown = this.default_otp_time
        this.otpValidateBtn.disabled = false;
        this.otpIncorrectElem.style.display ="none";
        this.phoneValidate();
    }

    enableCheckout() {
       this.checkoutLoadingElem.style.display = "none";
        this.checkoutBtnCart.style.display = "block";
      this.#checkoutBtn.disabled  = false;
    }
    
    resetElements() {
        this.#mobileError.style.display = "none";
        this.#mobileInput.classList.remove("border-error");
        this.#countryError.style.display = "none";
        this.#checkoutCartImage.display = "block";
        this.#checkoutLoadingImg.display = "hidden";
        
    }
   
    async getCartData() {
      
        this.#cartItems = [];
        const _fetch  = await fetch(window.Shopify.routes.root + "?sections=ecom-foreign-cart");
        const response = await _fetch.json();
       
        const cartDiv = document.createElement("div");
        cartDiv.innerHTML = response['ecom-foreign-cart']
       
        //get all script tags
        const allScripts = [...cartDiv.querySelectorAll("script")];
        if (allScripts.length == 0) {
             console.log("No items in the cart. returning without creating cartItems variable");
            return false;
        }
       
        for(let elem of allScripts) {
            const scriptData = JSON.parse(elem.innerText);
            this.#token = scriptData.token;
            this.#randomVal = scriptData.randomVal;
            this.#date = scriptData.date;
            this.#cartItems.push({ variant_id: scriptData.variant_id, qty: scriptData.itemCount, defaultPrice: scriptData.price, product_id: scriptData.product_id });
        }

        console.log(this.#cartItems);
        return true;
    }

    async promoMarginCartFix() {
      let _fetch  = await fetch(window.Shopify.routes.root + "?sections=ecom-foreign-cart");
      const response = await _fetch.json();
     
      const cartDiv = document.createElement("div");
      cartDiv.innerHTML = response['ecom-foreign-cart']
     
      //get all script tags
      const allScripts = [...cartDiv.querySelectorAll("script")];
      if (allScripts.length == 0) {
           console.log("No items in the cart. returning without creating cartItems variable");
          return true;
      }
  
      let ecomPromoCap = {}
      for(let i =0; i < allScripts.length ; i++) {
          const scriptData = JSON.parse(allScripts[i].innerText);
          
          if(scriptData.promoCap != "false") {
              const id = scriptData.variant_id;
              const promoCap = parseInt(scriptData.promoCap);
              const itemCount = scriptData.itemCount
              ecomPromoCap["prod"+id] = promoCap;
  
              if(itemCount > promoCap) {
                  const obj ={};
                  obj[id] = promoCap
                  await fetch(window.Shopify.routes.root + "cart/update.js", {
                      method: "POST",
                      headers: {
                          "Content-Type":"application/json"
                      },
                      body: JSON.stringify({updates: obj})
                  })
              }
          }
      }
  
      return true;
    }
}

window.ecomCheckoutObj = new ecomCheckout();

/*
async function ecomSendOtp (phone) {
  phone = phone.replace("+","");
  const today =  Date.now();
  let data = JSON.stringify({
      phone: phone,
      randDate:today
  });

  sessionStorage.setItem("tempNumber", phone);

  let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
  key = CryptoJS.enc.Utf8.parse(key);
  let iv = "O_1ltX'0Po>/hA*v";
  iv = CryptoJS.enc.Utf8.parse(iv);

  let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();

  const _fetch = await fetch(cryptedMobileValidate, {
    "method": "POST",
    headers:{
      "Content-Type":"application/json"
    },
    body: JSON.stringify({
      data:encrypted
    })
  });
  const result = await _fetch.text();
  console.log(result);
  return result;
}

async function ecomVerifyOtp(otp) {
  const today =  Date.now();
  mobile = sessionStorage.getItem("tempNumber");
  let data = JSON.stringify({
      phone: mobile,
      otp: otp,
      randDate:today
  });;
  console.log(data);
  console.log(otp);
  
  let key = ".(takP$5oK5Eut,]{4Voy1mzykhDP3Bo";
  key = CryptoJS.enc.Utf8.parse(key);
  let iv = "O_1ltX'0Po>/hA*v";
  iv = CryptoJS.enc.Utf8.parse(iv);

  let encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv }).toString();
  
  const _fetch = await fetch(cryptedOtpValidate, {
    method: "POST",
    headers:{
      "Content-Type":"application/json"
    },
    body: JSON.stringify({
      data:encrypted
    })
  });
  
  let response = await _fetch.text();
  console.log(response);

  let decrypted = CryptoJS.AES.decrypt(response, key, {
      iv: iv
  }).toString(CryptoJS.enc.Utf8);

  decrypted = JSON.parse(decrypted);
  console.log(decrypted)
  return decrypted;
}
*/